import { ReactElement } from 'react';
import { Chip } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import { getStatusName } from '../../../utility/delivery';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import InventoryIcon from '@mui/icons-material/Inventory';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { DeliveryStatus } from '../../../models/delivery/Delivery';

interface Props {
  data: DeliveryStatus;
}

export const getStatus = (status: DeliveryStatus): { label: string; color: any; icon: ReactElement } | undefined => {
  if (status == null) return undefined;
  switch (status) {
    case DeliveryStatus.new:
      return {
        label: getStatusName(status),
        color: 'primary',
        icon: <NewReleasesIcon sx={{ fill: '#fff', backgroundColor: 'transparent !important' }} />,
      };
    case DeliveryStatus.arranged:
      return {
        label: getStatusName(status),
        color: 'secondary',
        icon: <InventoryIcon sx={{ fill: '#fff', backgroundColor: 'transparent !important' }} />,
      };
    case DeliveryStatus.assigned:
      return {
        label: getStatusName(status),
        color: 'info',
        icon: <CompareArrowsIcon sx={{ fill: '#fff', backgroundColor: 'transparent !important' }} />,
      };
    case DeliveryStatus.inDelivery:
      return {
        label: getStatusName(status),
        color: 'warning',
        icon: <LocalShippingIcon sx={{ fill: '#fff', backgroundColor: 'transparent !important' }} />,
      };
    case DeliveryStatus.done:
      return {
        label: getStatusName(status),
        color: 'success',
        icon: <DoneIcon sx={{ fill: '#fff', backgroundColor: 'transparent !important' }} />,
      };
    default:
      return { label: 'Inaktív', color: 'default', icon: <CloseIcon /> };
  }
};

export const Status: React.FC<Props> = ({ data }: Props) => {
  const status = getStatus(data);
  return status ? (
    <Chip
      size="small"
      avatar={status.icon}
      sx={{ my: 0.3, minWidth: 125 }}
      color={status.color}
      label={status.label}
      onDelete={undefined}
    />
  ) : null;
};
